<template>
  <Dialog v-model:open="isOpen" content-class="w-fit sm:max-w-fit">
    <!-- 已在外部禁用按钮 -->
    <!-- <UpdateLatest v-if="status === 'undownload'" @close="isOpen = false" /> -->

    <UpdateProgress
      v-if="status === 'downloading'"
      @close="isOpen = false"
      @minimize="isOpen = false"
      @finish="handleUpdateFinish"
    />

    <UpdateSuccess v-else-if="status === 'finished'" @close="handleSuccess" />

    <UpdateError v-else-if="status === 'error'" @close="handleError" />
  </Dialog>
</template>

<script setup lang="ts">
  import { watch } from 'vue'
  import { Dialog, toast } from '@rapoo/element'
  import UpdateProgress from './UpdateProgress.vue'
  import UpdateSuccess from './UpdateSuccess.vue'
  import UpdateError from './UpdateError.vue'

  import { useUpdateStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  const updateStore = useUpdateStore()
  const { status } = storeToRefs(updateStore)
  const isOpen = defineModel<boolean>('open')

  const handleUpdateFinish = () => {}

  const handleSuccess = () => {
    isOpen.value = false
    updateStore.installUpdate()
  }

  const handleError = () => {
    isOpen.value = false
  }

  watch(
    () => status.value,
    (val) => {
      if (val === 'error') {
        toast.error('更新失败')
        isOpen.value = false
      }
    },
  )
</script>
